(function() {
  function initNorthgateAbout(root) {
    if (!root || root.dataset.northgateAboutInitialized === 'true') return;
    root.dataset.northgateAboutInitialized = 'true';

    var els = root.querySelectorAll('.ab-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    els.forEach(function(el) { io.observe(el); });
  }

  function initAll() {
    document.querySelectorAll('.northgate-about').forEach(initNorthgateAbout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initNorthgateAbout(event.target.querySelector('.northgate-about'));
  });
})();
